import { render, staticRenderFns } from "./PlansModal.vue?vue&type=template&id=fe85ecd2&"
import script from "./PlansModal.vue?vue&type=script&lang=js&"
export * from "./PlansModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports